/* ADD AND REMOVE MARGIN TO THE PAGE CONTAINER DYNAMICALLY BASED ON ANNOUNCEMENT BAR*/
 $(document).ready(function(){
   
     if( $('.header-announcement').css('display') == 'block' ) {
      $("#PageContainer").css("margin-top", "86.84px");
      $(".close-header-announcement").on("click", function(){
   /*console.log('Announcement closed!')*/
                     $("#PageContainer").css("margin-top", "54.53px");
                  });

   /*console.log('Announcement is on!');*/
    }
   
   else if ($('.header-announcement').css('display') == 'none' ) {
  $("#PageContainer").css("margin-top", "54.53px");
   /*console.log('Announcement is off!');*/
   }

   else {
   
        if(window.innerWidth < 768) {
 
    if( $('.header-announcement').css('display') == 'block' ) {
      $("#PageContainer").css("margin-top", "100px");
      $(".close-header-announcement").on("click", function(){
   /*console.log('Announcement closed!')*/
                     $("#PageContainer").css("margin-top", "65px");
                  });

   /*console.log('Announcement is on!');*/
    }
   
   else if ($('.header-announcement').css('display') == 'none' ) {
  $("#PageContainer").css("margin-top", "65px");
   /*console.log('Announcement is off!');*/
}}

}
   
 });

/* CONSOLE LOG ALL ELEMENTS THAT GO OUTSIDE THE VIEWPORT

var docWidth = document.documentElement.offsetWidth;

[].forEach.call(
  document.querySelectorAll('*'),
  function(el) {
    if (el.offsetWidth > docWidth) {
      console.log(el);
    }
  }
); */


/*-- Global site tag (gtag.js) - Google Analytics 
  
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'UA-102997401-1'); */

/* Google Tag Manager */
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-5N4SW5N');
/*End Google Tag Manager */
